import urlJoin from 'url-join';
import { AppSettings } from 'core/AppSettings';

export function getLoginUrl(): string {
  return urlJoin(AppSettings.authUrl, `?ReturnUrl=${encodeURI(AppSettings.omnisUrl)}`);
}
